// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n5Sq","content":"styles_content__-KfFa","tableWrap":"styles_tableWrap__3_UIy"};